// extracted by mini-css-extract-plugin
export default {"btn":"SliderArrow_btn__UACtv","right":"SliderArrow_right__aN6U5","left":"SliderArrow_left__eCRLq"};